import { IIncomeResponse } from 'services/cash-flow/income/types';
import { ICashFlowForm } from 'services/cash-flow/types';

export const incomeQueryToForm = (response: IIncomeResponse): ICashFlowForm => {
  const { incomeName, amount, id, ...income } = {
    ...response,
    name: response.incomeName,
    amountGross: parseFloat(response.amount.grossAmount.toFixed(2)),
    amountNet: parseFloat(response.amount.netAmount.toFixed(2)),
    settlementId: response.settlementId ?? '',
    settlementName: response.settlementName ?? '',
    repayments: response.repayments ?? [],
    contracts: [],
  };

  return income;
};
